import React from 'react';
import {Button} from "antd";
import classes from "./buttons.module.css";

const GreyButton = ({backgroundColor, fontColor, ...props}) => {
    // backgroundColor/fontColor — кастомные пропы, не пробрасываем их в DOM antd Button
    // (иначе React warning "does not recognize the `backgroundColor` prop on a DOM element");
    // визуально кнопка задаётся CSS-классом greyButton.
    return (
        <Button {...props} className={classes.greyButton}>
            <span>{props.children}</span>
        </Button>
    );
};

GreyButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default GreyButton;